import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useTheme } from 'styled-components/native'

import {
  DEFAULT_LYRA_SELECT_MICROSITE_CONFIG,
  LyraSelectMicrositeConfig,
  MicrositeConfigSectionNames,
} from '@lyrahealth-inc/shared-app-logic'
import { ThemeType } from '@lyrahealth-inc/ui-core-crossplatform'

import { getBeforeLaunch, getLwMobileEnabled } from '../../data/customer/customerSelectors'

export const useUpdatedLyraSelectMicrositeConfig: () => LyraSelectMicrositeConfig = () => {
  const isMobileAppDisabled = !useSelector(getLwMobileEnabled)
  const isComingSoon = useSelector(getBeforeLaunch)
  const {
    breakpoints: { isMobileSized },
    colors,
  } = useTheme() as ThemeType

  return useMemo(() => {
    const micrositeHideSections = {
      [MicrositeConfigSectionNames.MOBILE_APP_PROMO_BANNER]: {
        hideSection: isMobileSized || isMobileAppDisabled || isComingSoon,
        backgroundColor: undefined,
      },
      [MicrositeConfigSectionNames.MOBILE_APP_PROMO]: {
        hideSection: isMobileAppDisabled || isComingSoon,
        backgroundColor: colors.backgroundSecondary,
      },
      [MicrositeConfigSectionNames.CARE_NAVIGATOR]: {
        hideSection: false,
        backgroundColor: colors.backgroundSecondary,
      },
    }

    const comingSoonMicrositeHideSections = {
      [MicrositeConfigSectionNames.MOBILE_APP_PROMO_BANNER]: {
        hideSection: true,
        backgroundColor: undefined,
      },
      [MicrositeConfigSectionNames.MOBILE_APP_PROMO]: {
        hideSection: true,
        backgroundColor: undefined,
      },
      [MicrositeConfigSectionNames.LYRA_MEMBERSHIP]: {
        hideSection: false,
        backgroundColor: colors.backgroundSecondary,
      },
      [MicrositeConfigSectionNames.CARE_NAVIGATOR]: {
        hideSection: false,
        backgroundColor: colors.backgroundPrimary,
      },
    }

    const overrideHideSections = isComingSoon ? comingSoonMicrositeHideSections : micrositeHideSections

    return {
      ...DEFAULT_LYRA_SELECT_MICROSITE_CONFIG,
      ...overrideHideSections,
    }
  }, [colors.backgroundSecondary, isMobileAppDisabled, isMobileSized])
}
